// extracted by mini-css-extract-plugin
module.exports = {"Span":"EditableSpan_Span__1biHS","Input":"EditableSpan_Input__3x_aI","CharLimit":"EditableSpan_CharLimit__u5ICo","Form":"EditableSpan_Form__25eTF"};